module.exports = __webpack_public_path__ + "static/media/bnr2.999c6716.jpg";